import React, {Component} from 'react';

import Layout from '../../components/Layout'
import Settings from '../../pages/SettingsPage'
import Loading from '../../components/Base/Loading'

// import {withFirebase} from "../../components/Firebase";
 
class SettingsContainer extends Component {

	state = {
		leaveTypes: [],
		transportation: [],
		locations: [],
		students: [],
		faculties: [],
		parents: []
	}

	componentDidMount() {
		this.leaveTypeListener = this.returnLeaveTypeListener()
		this.transportListener = this.returnTransportListener()
		this.locationListener = this.returnLocationListener()
		this.studentsListener = this.studentsListener()
		this.facultyListener = this.facultyListener()
		this.parentsListener = this.returnParentsListener();
	}

	returnLeaveTypeListener = () => {
		const schoolRef = this.props.firebase.school('jm8UXoTsw4npkBtdWwoL')
		return schoolRef.collection('leave_types').orderBy('name', 'asc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
			this.setState({leaveTypes: result})
		})
	}

	returnTransportListener = () => {
		const schoolRef = this.props.firebase.school('jm8UXoTsw4npkBtdWwoL')
		return schoolRef.collection('transportation_types').orderBy('name', 'asc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
			this.setState({transportation: result})
		})
	}

	returnLocationListener = () => {
		const schoolRef = this.props.firebase.school('jm8UXoTsw4npkBtdWwoL')
		return schoolRef.collection('locations').orderBy('name', 'asc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
			this.setState({locations: result})
		})
	}

	returnParentsListener = () => {
		return this.props.firebase.parents().orderBy('last_name', 'asc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => {
				const data = doc.data();
				const activated = data.activated !== false ? true : false;
				result.push({id: doc.id, ...data, activated})
			});
			this.setState({parents: result})
		})
	}

	handleSubmitParent = (values) => {
		const {firebase, profile} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)
		try {
			firebase.parents().add({
				...values,
				creator_uid: profile.id,
				created_at: timestamp,
				last_updated: timestamp,
			})
		}catch (error) {
			console.log('failed to create parent', error)
		}
	}

	updateParent = (values) => {
		const {firebase} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)

		try {
			const itemID = values.id
			delete values.id
			firebase.parents().doc(itemID).update({
				...values,
				last_updated: timestamp
			})

		} catch (error) {
			console.log('failed to update parent', error)
		}
	}

	submitLeaveType = (values) => {
		const {firebase, profile} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)
		try {
			firebase.school('jm8UXoTsw4npkBtdWwoL').collection('leave_types').add({
				...values,
				creator_uid: profile.id,
				created_at: timestamp,
				last_updated: timestamp,
			})
		}catch (error) {
			console.log('failed to create leave type', error)
		}
	}

	updateLeaveType = (values) => {
		const {firebase} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)

		try {
			const itemID = values.id
			delete values.id
			firebase.school('jm8UXoTsw4npkBtdWwoL').collection('leave_types').doc(itemID).update({
				...values,
				last_updated: timestamp
			})

		} catch (error) {
			console.log('failed to update leave type', error)
		}
	}

	submitTransportType = (values) => {
		const {firebase, profile} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)
		try {
			firebase.school('jm8UXoTsw4npkBtdWwoL').collection('transportation_types').add({
				...values,
				creator_uid: profile.id,
				created_at: timestamp,
				last_updated: timestamp,
			})
		}catch (error) {
			console.log('failed to create leave type', error)
		}
	}

	updateTransportType = (values) => {
		const {firebase} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)

		try {
			const itemID = values.id
			delete values.id
			firebase.school('jm8UXoTsw4npkBtdWwoL').collection('transportation_types').doc(itemID).update({
				...values,
				last_updated: timestamp
			})

		} catch (error) {
			console.log('failed to update leave type', error)
		}
	}

	submitLocation = (values) => {
		const {firebase, profile} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)
		try {
			firebase.school('jm8UXoTsw4npkBtdWwoL').collection('locations').add({
				...values,
				creator_uid: profile.id,
				created_at: timestamp,
				last_updated: timestamp,
			})
		}catch (error) {
			console.log('failed to create leave type', error)
		}
	}

	updateLocation = (values) => {
		const {firebase} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)

		try {
			const itemID = values.id
			delete values.id
			firebase.school('jm8UXoTsw4npkBtdWwoL').collection('locations').doc(itemID).update({
				...values,
				last_updated: timestamp
			})

		} catch (error) {
			console.log('failed to update leave type', error)
		}
	}

	handleRequestNotification = async () => {
		let studentRef = this.props.firebase.student(localStorage.getItem('uid'));
		const messaging = this.props.firebase.messaging;
		messaging.requestPermission().then(function () {
			console.log('Notification permission granted.');
			// TODO(developer): Retrieve an Instance ID token for use with FCM.
			localStorage.setItem('WAVE_NOTIFICATIONS', true);
			messaging.getToken().then(token => {
				console.log('new token', token);
				studentRef.update({
					fmcToken: token
				})
			})
		}).catch(function (err) {
			console.log('Unable to get permission to notify.', err);
		});
	};

	/**
	 * Configuration Students Handlers
	 */

	studentsListener = () => {
		return this.props.firebase.students().orderBy('last_name', 'asc').onSnapshot(async snapshot => {
			let result = [];
			let parentRef = await this.props.firebase.parents().get();
			let parents = {};
			parentRef.forEach(doc => {
				parents[doc.id] = doc.data();
			});
			snapshot.forEach(doc => {
				let data = doc.data();
				let parentsIds  = data.parents || [];
				let parents_data = [];
				parentsIds.forEach(pId => {
					parents[pId] && parents_data.push(parents[pId]);
				})
				const activated = data.activated !== false ? true : false;
				result.push({id: doc.id, ...data, parents_data, activated})
			});
			this.setState({students: result});
		})
	}

	submitStudent = async (values) => {
		/**
		 * Save Parent info into Parent Collection first
		 */
		try {
			let parentsIds = []
			/**
			 * Save Parents Info
			 */
			const { parents_data } = values;
			for(let i in parents_data) {
				let pRef = await this.props.firebase.parents().add(parents_data[i]);
				parentsIds.push(pRef.id);
			}
			delete values.parents_data;
			/**
			 * Save Student Info
			*/
			const newStudent = {
				parents: parentsIds,
				...values,
				is_modified: true
			}
			await this.props.firebase.students().add(newStudent);
		} catch (error) {
		  console.log(error);
		}
	}

	updateStudent = async (values) => {
		try{
			if(values.is_modified !== true) {
				const { id } = values;
				const { activated, auth_uid } = values;
				/**
				 *  Disable Authentication of inactive user 
				 */
				if(auth_uid) {
					this.props.firebase.modifyAuth(auth_uid, !activated);
				}
				delete values.id;
				delete values.parents_data;
				await this.props.firebase.student(id).update(values);
			} else {
				let parentsIds = values.parents;
				const { activated, auth_uid } = values;
				/**
				 *  Disable Authentication of inactive user 
				 */
				if(auth_uid) {
					this.props.firebase.modifyAuth(auth_uid, activated);
				}
				/**
				 * Update Parents Info
				 */
				const { parents_data } = values;
				for(let i in parentsIds) {
					await this.props.firebase.parent(parentsIds[i]).update(parents_data[i]);
				}
				delete values.parents_data;
				const { id } = values;
				delete values.id;
				await this.props.firebase.student(id).update(values);
			}
		} catch(error) {
			console.log(error);
		}
	}
	
	/**
	 * Configuration Faculties Handlers
	 */
	facultyListener = () => {
		return this.props.firebase.faculties().orderBy('last_name', 'asc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => {
				let data = doc.data();
				let activated = data.activated !== false ? true : false;
				result.push({id: doc.id, ...data, activated})
			});
			this.setState({faculties: result})
		})
	}

	submitFaculty = async (values) => {
		const newFaculty = {
			...values,
			is_modified: true
		}
		try {
			await this.props.firebase.faculties().add(newFaculty);
		} catch(error) {
			console.log(error);
		}
	}

	updateFaculty = async (values) => {
		try {
			if(values.is_modified !== true) {
				const { id } = values;
				const { activated, auth_uid } = values;
				/**
				 *  Disable Authentication of inactive user 
				 */
				if(auth_uid) {
					this.props.firebase.modifyAuth(auth_uid, !activated);
				}
				delete values.id;
				await this.props.firebase.faculty(id).update(values);
			} else {
				const { id } = values;
				delete values.id;
				const { activated, auth_uid } = values;
				/**
				 *  Disable Authentication of inactive user 
				 */
				if(auth_uid) {
					this.props.firebase.modifyAuth(auth_uid, !activated);
				}
				await this.props.firebase.faculty(id).update(values);
			}
		} catch(error) {
			console.log(error);
		}
	}

	componentWillUnmount() {
		this.leaveTypeListener()
		this.locationListener()
		this.transportListener()
		this.studentsListener()
		this.facultyListener()
	}

	render() {
		const {leaveTypes, transportation, locations, students, faculties, parents} = this.state;
		return (
			<Layout noSideBar {...this.props}>
				{this.props.profile === null || this.props.profile === undefined ? <Loading/>:
					<Settings
						{...this.props}
						leaveTypes={leaveTypes}
						transportation={transportation}
						locations={locations}
						students={students}
						faculties={faculties}
						parents={parents}
						updateRequestNotification={this.handleRequestNotification}
						handleUpdateLeaveType={this.updateLeaveType}
						handleSubmitLeaveType={this.submitLeaveType}
						handleSubmitTransport={this.submitTransportType}
						handleSubmitLocation={this.submitLocation}
						handleSubmitStudent={this.submitStudent}
						handleSubmitFaculty={this.submitFaculty}
						handleSubmitParent={this.handleSubmitParent}
						handleUpdateTransport={this.updateTransportType}
						handleUpdateLocation={this.updateLocation}
						handleUpdateStudent={this.updateStudent}
						handleUpdateFaculty={this.updateFaculty}
						handleUpdateParent={this.updateParent}
					/>
				}
			</Layout>
		);
	}
}


export default SettingsContainer;
